

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { ControllerDeletePlanSeguro, ControllerEliminarSeguro, ControllerListarPlanesSeguro, ControllerListarSegurosClinica } from '../../../Service/Services.seguros';
import { GetTokenDecoded } from '../../../utils/storeUsuario';
import CreateSeguro from './CreateSeguro';
import ModalCreaPlan from './ModalCreaPlan';
import usePermissions from '../../../hook/usePermissions';
import useListaLocal from '../../../hook/useListaLocal';
import DataTable from '../../UI/DataTable/DataTable';
import { Celda, CeldaDoble } from '../../UI/DataTable/piezas';
import MenuAcciones from '../../UI/MenuAcciones';
import Boton from '../../UI/Boton';
import ModalKit from '../../UI/Modal/Modal';
import { useToast, Aviso } from '../../UI/Aviso';
import { CampoTexto } from '../../UI/Campo';
import { IconoMas, IconoEditar, IconoEliminar, IconoEscudo, IconoBuscar } from '../../UI/Iconos';


export default function Seguros({tabs}) {
    // RBAC-CUTOVER-07: Nuevo/Editar dependen de seguros.create/seguros.edit,
    // Eliminar de seguros.delete (backend ya los exige en seguros.routes.ts,
    // igual para seguro y plan de seguro).
    const { hasPermission } = usePermissions();
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [showPlan, setShowPlan] = useState(false);
    const [showCreaPlan, setShowCreaPlan] = useState(false);

    const [editSeguro, setEditSeguro] = useState(null)

    const [listSeguro, setListSeguro] = useState([])
    const [listPlan, setListPlan] = useState([])

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [ping, setPing] = useState(false)

    const [idseguro, setIdseguro] = useState(null)
    // Qué se está a punto de borrar: { tipo: "seguro" | "plan", fila }
    const [porBorrar, setPorBorrar] = useState(null)
    const [borrando, setBorrando] = useState(false)
    const { mostrar } = useToast();
    const lista = useListaLocal(listSeguro, { campos: ["nombre", "ruc", "razon_social", "responsable"] });

    const handleClose = () => setShow(false);
    const handleShow = () => {
      setEditSeguro(null);
      setShow(true)
    };
    const handlePlanClose = () => setShowPlan(false);
    const handlecreaPlanClose = (seguro) => {
      setEditSeguro(seguro)
      setShowCreaPlan(!showCreaPlan)
    };

    useEffect(() => {
        (async()=>{
          setLoading(true)
          const response = await ControllerListarSegurosClinica(GetTokenDecoded().idclinica)
          if(response){
            setListSeguro(response)
            setError(null)
          } else {
            // Antes, un fallo dejaba `loading` en true para siempre.
            setListSeguro([])
            setError("No se pudo obtener el listado de seguros.")
          }
          setLoading(false)
        })()
        // La dependencia era `tabs.clinicas` -- de otra sección. Funcionaba de
        // milagro porque el efecto corre igual al montar. Ahora observa la suya.
    }, [ping, tabs.seguros])

    const editarSeguro= (segruo) => {
      setEditSeguro(segruo)
      setShow(true)
    }

    const DeleteSeguro = async(idseguro) => {
        const response = await ControllerEliminarSeguro(idseguro)
        if(response){
          setPing(!ping)
          mostrar({ tipo: "exito", texto: "Seguro eliminado con éxito" })
        }else{
          mostrar({ tipo: "error", texto: "Ocurrió un error en la operación, por favor intente nuevamente" })
        }
    }

    const EliminarPlan = async(id) => {
      const response = await ControllerDeletePlanSeguro(id)
      if(response){
          mostrar({ tipo: "exito", texto: "El plan ha sido eliminado." })
          setPing(!ping)
      }else{
          mostrar({ tipo: "error", texto: "Ha ocurrido un error." })
      }
    }

    const confirmarBorrado = async () => {
      const { tipo, fila } = porBorrar;
      setBorrando(true);
      if (tipo === "seguro") await DeleteSeguro(fila.idseguro);
      else await EliminarPlan(fila.idplanseguro);
      setBorrando(false);
      setPorBorrar(null);
    };

    const openPlanSeguros = async (idseguro) => {
      if(idseguro){
        setIdseguro(idseguro)
        const response = await ControllerListarPlanesSeguro(idseguro)
        if(response){
          setListPlan(response)
        }
      }else{
        setListPlan([])
      }
      setShowPlan(!showPlan)
    }

    useEffect(() => {
      (async()=>{
        if(idseguro){
          setIdseguro(idseguro)
          const response = await ControllerListarPlanesSeguro(idseguro)
          if(response){
            setListPlan(response)
          }
        }
      })()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ping])

    const columnas = [
      { key: "idseguro", titulo: "#", ancho: 60, alinear: "derecha", render: (s) => <Celda valor={s.idseguro} mono /> },
      {
        // El nombre comercial y la razón social son la misma identidad.
        key: "nombre",
        titulo: "Seguro",
        render: (s) => <CeldaDoble principal={s.nombre} secundario={s.razon_social} />,
      },
      { key: "ruc", titulo: "RUC", ancho: 160, render: (s) => <Celda valor={s.ruc} mono /> },
      {
        key: "responsable",
        titulo: "Representante",
        ancho: 240,
        render: (s) => <CeldaDoble principal={s.responsable} secundario={s.telefono} />,
      },
      {
        key: "acciones",
        titulo: "",
        ancho: 60,
        alinear: "centro",
        render: (s) => {
          const acciones = [];
          if (hasPermission("seguros.edit")) {
            acciones.push({ label: "Editar", icono: IconoEditar, onClick: () => editarSeguro(s) });
          }
          // Ver/agregar planes nunca tuvo permiso propio: se mantiene igual.
          acciones.push({ label: "Agr. Plan", icono: IconoEscudo, onClick: () => openPlanSeguros(s.idseguro) });
          if (hasPermission("seguros.delete")) {
            acciones.push({
              label: "Eliminar",
              icono: IconoEliminar,
              peligro: true,
              onClick: () => setPorBorrar({ tipo: "seguro", fila: s }),
            });
          }
          return <MenuAcciones acciones={acciones} titulo={`Acciones de ${s.nombre}`} />;
        },
      },
    ];

    const columnasPlan = [
      { key: "plan", titulo: "Plan", render: (p) => <Celda valor={p.plan} /> },
      {
        key: "copago",
        titulo: (
          <span title="Porcentaje de copago que se le aplicará al paciente en la consulta">Copago</span>
        ),
        ancho: 120,
        alinear: "derecha",
        render: (p) => <Celda valor={`${p.copago}%`} mono />,
      },
      {
        key: "acciones",
        titulo: "",
        ancho: 60,
        alinear: "centro",
        render: (p) => {
          const acciones = [];
          if (hasPermission("seguros.edit")) {
            acciones.push({ label: "Editar", icono: IconoEditar, onClick: () => handlecreaPlanClose(p) });
          }
          if (hasPermission("seguros.delete")) {
            acciones.push({
              label: "Eliminar",
              icono: IconoEliminar,
              peligro: true,
              onClick: () => setPorBorrar({ tipo: "plan", fila: p }),
            });
          }
          return acciones.length > 0 ? <MenuAcciones acciones={acciones} titulo={`Acciones del plan ${p.plan}`} /> : null;
        },
      },
    ];

  return (
    <section>
      {/* SEGUROS-PLANES FASE 1 · puerta de entrada al flujo nuevo.
          Esta pestaña NO cambia: sigue siendo la de siempre, con su alta, su
          edicion y sus planes de seguro. Lo unico que gana es la salida hacia
          la ficha, que hoy no existe -- al crear un seguro te quedas en la
          lista sin ningun camino hacia su tarifario o sus planes.
          Convivencia deliberada mientras se valida lo nuevo. */}
      <Aviso
        tipo="info"
        accion={{ label: "Abrir aseguradoras", onClick: () => navigate("/configuracion/seguros") }}
      >
        El tarifario, los planes y las promociones de cada aseguradora ya se pueden gestionar
        desde su propia ficha, sin volver a elegir el seguro en cada pantalla.
      </Aviso>

      {hasPermission("seguros.create") && (
        <div className="d-flex justify-content-end mb-3">
          <Boton variante="primario" icono={IconoMas} onClick={handleShow} data-testid="seguro-crear">
            Crear Seguro
          </Boton>
        </div>
      )}

      <div className="mb-3" style={{ maxWidth: 380 }}>
        <CampoTexto
          etiqueta="Buscar seguro"
          icono={IconoBuscar}
          placeholder="Nombre, RUC, razón social o representante"
          value={lista.texto}
          onChange={(e) => lista.setTexto(e.target.value)}
          data-testid="seguro-buscar"
        />
      </div>

      <DataTable
        columnas={columnas}
        filas={lista.visibles}
        filaKey="idseguro"
        cargando={loading}
        error={error}
        onReintentar={() => setPing(!ping)}
        etiquetaTabla="Seguros de la clínica"
        hayFiltrosAplicados={lista.hayBusqueda}
        onLimpiarFiltros={lista.limpiar}
        textoVacioSinFiltros="Esta clínica todavía no tiene seguros registrados."
        paginacion={lista.paginacion}
      />

      {/* Planes del seguro */}
      <ModalKit
        abierto={showPlan}
        titulo="Planes del seguro"
        ancho="contenido"
        onCerrar={handlePlanClose}
        secundario={{ label: "Cerrar" }}
      >
        {hasPermission("seguros.create") && (
          <div className="d-flex justify-content-end mb-3">
            <Boton tamano="sm" variante="primario" icono={IconoMas} onClick={() => handlecreaPlanClose(null)} data-testid="plan-crear">
              Crear Plan
            </Boton>
          </div>
        )}
        {/* La columna "Plan" mostraba el nombre del plan y, al lado, otra
            columna "Plan" con el texto fijo "Plan Basico" para TODAS las filas.
            No es un dato: era relleno. Se quita. */}
        <DataTable
          columnas={columnasPlan}
          filas={listPlan}
          filaKey="idplanseguro"
          etiquetaTabla="Planes del seguro"
          textoVacioSinFiltros="Este seguro todavía no tiene planes."
        />
      </ModalKit>

      {/* Antes las dos confirmaciones decían "¿Estás seguro de eliminar esta
          CLÍNICA?" -- copiado de otra sección -- y el mensaje de éxito decía
          "Clinica eliminda con exito". Se borraba un seguro. */}
      <ModalKit
        abierto={Boolean(porBorrar)}
        titulo={porBorrar?.tipo === "plan" ? "Eliminar plan" : "Eliminar seguro"}
        destructivo
        onCerrar={() => setPorBorrar(null)}
        secundario={{ label: "Cancelar" }}
        primario={{ label: "Eliminar", cargando: borrando, onClick: confirmarBorrado }}
      >
        <p>
          Vas a eliminar {porBorrar?.tipo === "plan" ? "el plan" : "el seguro"}{" "}
          <b>{porBorrar?.tipo === "plan" ? porBorrar?.fila?.plan : porBorrar?.fila?.nombre}</b>. Esta acción no se
          puede deshacer.
        </p>
      </ModalKit>

      <ModalCreaPlan
        showCreaPlan={showCreaPlan}
        handlecreaPlanClose={handlecreaPlanClose}
        editarPlan={editSeguro}
        idseguro={idseguro}
        setPing={setPing}
        ping={ping}
      />


      <Offcanvas style={{ width: '50%' }} placement="end" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {editSeguro ? 'Actualizar Seguro' : 'Crear Seguro' }
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <CreateSeguro
            setPing={setPing}
            ping={ping}
            handleClose={handleClose}
            show={show}
            editSeguro={editSeguro}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </section>
  )
}
